// extracted by mini-css-extract-plugin
export default {"advertTab":"PjQ+4D4v"};